<template>
	<div
		class="spanMappedValuesEditor__item"
		:class="{
			'is-checkable': canCheck,
		}"
	>
		{{ log("rendered") }}
		<BCheckbox
			class=" spanMappedValuesEditor__item__checkbox"
			:value="isChecked"
			@input="handleCheckChange"
			:optionValue="spanDescription.id"
			:label="$t.apply(this, spanDescription.longLabel())"
		></BCheckbox>

		<BFieldNumber
			class="spansTable__field spanMappedValuesEditor__item__field"
			:value="value"
			@input="handleUpdateValue"
			v-bind="fieldProps"
			size="s/m"
		/>
	</div>
</template>

<script>
import BCheckbox from "@/components/base/BCheckbox.vue";
import BFieldBlock from "@/components/base/BFieldBlock.vue";
import BFieldNumber from "@/components/base/BFieldNumber.vue";
export default {
	components: {
		BCheckbox,
		BFieldBlock,
		BFieldNumber,
	},
	props: {
		spanDescription: {
			type: Object,
			required: true,
		},
		isChecked: {
			type: Boolean,
			required: true,
		},
		value: {
			type: Number,
			required: true,
		},
		fieldProps: {
			type: Object,
			required: true,
		},
		canCheck: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	methods: {
		log: window.console.log.bind(window),
		handleCheckChange(checked) {
			this.$emit("check", this.spanDescription, checked);
		},
		handleUpdateValue(value) {
			this.$emit("updateValue", this.spanDescription, value);
		},
	},
};
</script>

<style lang="scss">
.spanMappedValuesEditor__item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 5px 41px 5px 5px;
}

.spanMappedValuesEditor__item__field {
}

.spanMappedValuesEditor__item__checkbox  {
	white-space: nowrap;
	width: 20rem;
}
</style>
